import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useRecommendationDialogStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
  },
  prompt: {
    overflowX: 'hidden',

    '& .fai-Textarea__count': {
      position: 'absolute',
      bottom: tokens.spacingHorizontalXL,
      left: tokens.spacingHorizontalXL,
    },
  },
  loading: {
    display: 'flex',
    alignContent: 'flex-start',
    height: '40px',
    ...shorthands.overflow('hidden'),
  },
});
